import { render, staticRenderFns } from "./ContentsList.vue?vue&type=template&id=a20512ca&scoped=true&lang=pug"
import script from "./ContentsList.vue?vue&type=script&lang=ts"
export * from "./ContentsList.vue?vue&type=script&lang=ts"
import style0 from "./ContentsList.vue?vue&type=style&index=0&id=a20512ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20512ca",
  null
  
)

export default component.exports